




































































import { mapActions } from 'vuex';
import { GPageBase } from '@/mixins';
import { GEnum } from '@/constants/enum.defination';
import { StringUtils } from '@/utils/string.utils';
import { required } from 'vuelidate/lib/validators';
import Component, { mixins } from 'vue-class-component';
import { resetPasswordModule } from '@/store/modules/entities/reset-password.module';
import GVTag from '@/components/GVTag.vue';
import { MesssgeModal } from '@/models/message-modal';
import { Constants } from '@/constants/constants';

@Component({
  name: 'GResetPasswordStep1',
  components: {
    GVTag,
  },
  methods: {
    ...mapActions(['handleBackToHome']),
  },
  validations: {
    email: { required },
    form: ['email'],
  },
})
export default class GResetPasswordStep1 extends mixins(GPageBase) {
  isEmailSend: boolean = false;
  messageModal: MesssgeModal = { type: GEnum.MessageType.Success, isShow: false, isContinue: false };
  messageType = GEnum.MessageType;

  handleSendEmail() {
    this.$v.email.$touch();
    if (this.isPageInvalid) {
      return;
    }
    resetPasswordModule.sendEmail().then(_ => {
      this.messageModal.type = GEnum.MessageType.Success;
      this.messageModal.title = this.INFO_TITLE;
      this.messageModal.content = this.$t('SEND_MAIL_SUCCESS').toString();
      this.messageModal.isShow = true;
      /*
      this.isEmailSend = true;
      this.showMessage(GEnum.MessageType.Success, `${this.email}<br />${this.$t('SEND_MAIL_SUCCESS').toString()}`, 5);
      this.email = '';
      this.$v.email.$reset();
      this.$router.push({ name: 'signin' });
      */
    });
  }

  handleSendEmailByEnterKey($event: KeyboardEvent) {
    if ($event.charCode == 13 && $event.key == 'Enter') {
      if (this.isEmptyAndInvalidEmail) {
        return;
      }
      this.handleSendEmail();
    }
  }

  get isPageInvalid() {
    return this.isEmptyEmail || this.isInvalidEmail;
  }

  get isEmptyEmail(): boolean {
    return this.$v.email.$dirty && this.$v.email.$invalid;
  }

  get isInvalidEmail(): boolean {
    return this.$v.email.$dirty && this.isEmptyEmail == false && StringUtils.isValidEmail(this.email) == false;
  }

  get isEmptyAndInvalidEmail(): boolean {
    return this.isEmptyEmail || this.email.length == 0 || this.isInvalidEmail;
  }

  get email(): string {
    return resetPasswordModule.email;
  }

  set email(value: string) {
    resetPasswordModule.setEmail(value);
  }

  get isJgrow(): boolean {
    return process.env.VUE_APP_SERVICE_NAME === Constants.ServiceNameJgrow;
  }

  handleBackToLogin() {
    this.$router.push(`/signin`);
  }
}
